
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DosyaBorcluIsyeriSgkCevap } from '@/plugins/uyap-plugin/uyap/DosyaBorcluIsyeriSgk';

@Component({})
export default class IsyeriDetay extends Vue {
  @Prop() data!: DosyaBorcluIsyeriSgkCevap;

  yoneticiHeaders = [
    { text: 'Ad Soyad', value: 'TY_AD' },
    { text: 'TC Kimlik', value: 'TY_MERNIS_NO' },
    { text: 'Doğum', value: 'TY_DOGUM_TARIH' },
    { text: 'Baba Adı', value: 'TY_BABA_AD' },
    { text: 'Anne Adı', value: 'TY_ANA_AD' },
    { text: 'Ünvan', value: 'TY_YKOD_ACIKLAMA' }
  ];

  get isyeriList() {
    return this.data.sorguSonucDVO?.isYeriBilgi?.isyeriList || [];
  }
}
